<template>
  <div class="content" id="address-input">
    <div class="holder container">
      <div class="content-body col-md-7 col-10">
        <div class="form-group">
          <label>{{$t('front_end.a075.zip_code')}}</label>
          <div class="row m-0">
            <input type="text" pattern="\d*" class="form-control col-4" ref="zip_code"
                   id="zip-code" maxlength="7" v-model.trim="zipCode"/>
            <div class="col-6 col-md-3 row button-auto-input p-0">
              <button class="btn-custom offset-1">
                {{$t('front_end.a075.auto_input')}}
              </button>
            </div>
          </div>
          <div class="error-msg">{{errors.zipCode}}</div>
        </div>
        <div class="form-group">
          <label>{{$t('front_end.a075.address')}}</label>
          <div class="select-box">
            <select class="form-control" v-model="prefecture" ref="prefecture">
              <option v-for="(pref, index) in prefectureList" :key="index" :selected="pref === prefecture">{{pref}}
              </option>
            </select>
          </div>
          <div class="error-msg">{{errors.prefecture}}</div>
        </div>
        <div class="form-group">
          <label>{{$t('front_end.a075.address_district')}}</label>
          <input maxlength="255" type="text" class="form-control" v-model.trim="city" ref="city"/>
          <div class="error-msg">{{errors.city}}</div>
        </div>
        <div class="form-group">
          <label>{{$t('front_end.a075.street')}}</label>
          <input maxlength="255" type="text" class="form-control" v-model.trim="street" ref="street"/>
          <div class="error-msg">{{errors.street}}</div>
        </div>
        <div class="form-group">
          <label>{{$t('front_end.a075.building')}}</label>
          <input maxlength="255" type="text" class="form-control" v-model.trim="building" ref="building"/>
          <div class="error-msg">{{errors.building}}</div>
        </div>
        <div class="form-group">
          <label>{{$t('front_end.a075.city_name')}}</label>
          <input maxlength="255" type="text" class="form-control" v-model.trim="company" ref="company"/>
          <div class="error-msg">{{errors.company}}</div>
        </div>
        <div class="form-group">
          <label>{{$t('front_end.a075.deploy_name')}}</label>
          <input maxlength="255" type="text" class="form-control" v-model.trim="department" ref="department"/>
          <div class="error-msg">{{errors.department}}</div>
        </div>
        <div class="form-group">
          <label>{{$t('front_end.a075.position')}}</label>
          <input maxlength="255" type="text" class="form-control" v-model.trim="position" ref="position"/>
          <div class="error-msg">{{errors.position}}</div>
        </div>
        <div class="form-group">
          <label>{{$t('front_end.a075.name')}}</label>
          <div class="input-name-body">
            <input maxlength="255" type="text" class="form-control input-name"
                   :placeholder="$t('front_end.a075.first_name')" v-model.trim="firstName" ref="first_name"/>
            <input maxlength="255" type="text" class="form-control input-name"
                   :placeholder="$t('front_end.a075.last_name')" v-model.trim="lastName" ref="last_name"/>
            <input maxlength="255" type="text" class="form-control input-name"
                   :placeholder="$t('front_end.a075.honorific_title')" v-model.trim="honorificName" ref="honorific_name"/>
          </div>
          <div class="input-name-body" v-if="(nameErrorFormatNumber + nameErrorEmptyNumber) === 1">
            <div class="error-msg">{{ errors.firstName || errors.lastName || errors.honorificName}}</div>
          </div>
          <div class="input-name-body" v-else-if="nameErrorFormatNumber > 0 && (nameErrorFormatNumber + nameErrorEmptyNumber) > 1">
            <div class="error-msg">{{ $t('front_end.a075.validate.name_error_format') }}</div>
          </div>
          <div class="input-name-body" v-else-if="nameErrorEmptyNumber > 1 && nameErrorFormatNumber === 0">
            <div class="error-msg">{{ $t('front_end.a075.validate.name_error_empty') }}</div>
          </div>
          <div class="form-group" id="group${number}">
            <label>連名1</label>
            <div class="content-input-add">
              <input maxlength="255" type="text" class="form-control input-name"
                    :placeholder="$t('front_end.a055.last_name')" v-model.trim="lastName" ref="last_name"/>
              <input maxlength="255" type="text" class="form-control input-name"
                    :placeholder="$t('front_end.a055.honorific_title')" v-model.trim="honorificName" ref="honorific_name"/>
              <div class="input-name body-item-delete">
                <i class="fa item-delete" id="${textLabel}${number}" data-menu="${number}">&#xf056;</i>
                <font-awesome-icon icon="minus-circle" id="icon-minus" class="icon-add"></font-awesome-icon>
              </div>
            </div>
            <div class="row align-items-baseline">
              <div class="error-msg col-xl-4" id="name-error${number}"></div>
              <div class="error-msg col-xl-4 pr-0" id="honorific-error${number}"></div>
              <div class="width-error-name"></div>
            </div>
          </div>
        </div>
        <div v-html="rawHtmlInputField" class="form-group mb-0"></div>
        <div class="plus-sub-name justify-content-center d-flex mt-5">
          <font-awesome-icon icon="plus-circle" id="icon-plus"
                             :class="['icon-add', {'disable-btn-add':numberSub === 20}]"
                            ></font-awesome-icon>
          <label :class="[{'disable-btn-add':numberSub === 20}, 'text-add-plus']">{{$t('front_end.a075.text_add_plus')}}</label>
        </div>
      </div>
      <div class="footer-btn">
        <button class="btn-confirm-input btn-custom col-md-4 col-8">
          {{$t('front_end.a075.confirm')}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "a075",
  data() {
    return {
      numberSub: 0,
      rawHtmlInputField: '',
      zipCode: '',
      city: '',
      prefecture: '',
      street: '',
      building: '',
      company: '',
      department: '',
      position: '',
      firstName: '',
      lastName: '',
      honorificName: '',
      subReceiverListTemp: [],
      prefectureList: [],
      confirmModal: false,
      insertComplete: false,
      buttonConfirm: this.$t('front_end.a075.yes'),
      buttonCancel: this.$t('front_end.a075.cancel'),
      messageConfirm: this.$t('front_end.a075.message_confirm'),
      nameErrorFormatNumber: 0,
      nameErrorEmptyNumber: 0,
      errors: {
        firstName: '',
        lastName: '',
        honorificName: '',
        zipCode: '',
        prefecture: '',
        city: '',
        street: '',
        company: '',
        department: '',
        position: '',
        subReceiver: ''
      }
    };
  },
}
</script>

<style scoped src="../../assets/css/toAddressInput/toAddressInput.css"></style>
